import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShellSideMenuLocationService {
    public readonly locationMenuDisabled = signal<boolean>(false);
}
